import { useUserStore } from '@/store/modules/user/store.js';

const can = (permission) => {
    return !!useUserStore().authUserAbilities.includes(permission);
};

export const canPlugin = {
    install(app) {
        app.config.globalProperties.$can = can;
        app.provide('$can', can);
    },
};

export default can;
